import { fetchJson } from '@shared/api/base';
import type { BlogFeedResponse } from '../types';

export interface BlogFeedParams {
  subCategory?: string | null;
  limit?: number;
  cursor?: string | null;
}

export async function fetchBlogFeed(params: BlogFeedParams): Promise<BlogFeedResponse> {
  const searchParams = new URLSearchParams();

  if (params.subCategory) {
    searchParams.set('subCategory', params.subCategory);
  }

  if (params.limit !== undefined) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.cursor) {
    searchParams.set('cursor', params.cursor);
  }

  const qs = searchParams.toString();
  return fetchJson<BlogFeedResponse>(`/api/blog/feed${qs ? `?${qs}` : ''}`);
}
